import { get } from "../../service/api";

const ExportBankTransactionLog = async ({
  accountNumber,
  startDate,
  endDate,
  format,
}) => {
  const qs = [
    `accountNumber=${encodeURIComponent(accountNumber)}`,
    `startDate=${encodeURIComponent(startDate)}`,
    `endDate=${encodeURIComponent(endDate)}`,
  ];
  if (format) qs.push(`format=${encodeURIComponent(format)}`);
  return get(`/admin/bankTransactionLog/export?${qs.join("&")}`);
};

export default ExportBankTransactionLog;
